export default __webpack_public_path__ + "static/media/DC Logo_Horizontal.11bdebaf.png";